const OurStory = ({companyDetail}) => {
    return(
    <>
       <section className="fresh-vegetable-section">
                <div className="container-fluid-lg">
                    <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
                        <div className="col-xl-4 col-12">
                            <div className="fresh-image-2">
                                <img
                                style={{width:"100%"}}
                                    src="../assets/images/perfume/about_story.jpg"
                                    className="bg-img lazyloaded"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className="col-xl-8 col-12 bg-white">
                            <div className="fresh-contain p-center-left">
                                <div>
                                    <div class="about-us-title">
                                        <h3 className='inter-font'>The Valorelle Story</h3>
                                        <h2>{companyDetail.company_story_heading}</h2>
                                    </div>
                                    <div dangerouslySetInnerHTML={{ __html: companyDetail.company_story }} className='editor inter-font'></div>

                                    {/* <div className="delivery-list">
                                        <p className="text-content">
                                            We grew up in a world where perfumes came with labels. One shelf for women. Another for men. And nothing for anyone who didn’t fit those boxes.</p>
                                        <p className="text-content">
                                            But scent is so much more than that. It’s memory, emotion, presence — and above all, identity.
                                            Valorelle was born from that idea: that fragrance should be free from rules — not pink for her and musk for him, but notes that move with you, moods that belong to you.</p>
                                        <p className="text-content">
                                            We set out to create something different. Gender-inclusive perfumes — rich, layered, and long-lasting — made right here in India. Fragrances with high projection, elegant bottles, and no compromises on quality.</p>
                                        <p className="text-content">
                                            Luxury in feel, but not in price. Because smelling good should never be a privilege — it should be personal, powerful, and possible for everyone.
                                            This is fragrance the way it should be: a story you tell, not one you’re told.

                                        </p>

                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    </>)
}

export default OurStory;